import React, { 
    createContext,
    PropsWithChildren,
    useRef,
    RefObject,
    useContext
 } from 'react'

 export const MenuPanelContext = createContext<RefObject<HTMLDivElement>>({} as RefObject<HTMLDivElement>)

 export const MenuPanelProvider = ({
    children
}: PropsWithChildren<{}>) => {
    const divRef = useRef<HTMLDivElement>(null)

    return (
        <MenuPanelContext.Provider value={divRef}>
           {children}
        </MenuPanelContext.Provider>
    )
}

export const useMenuPanel = () => useContext(MenuPanelContext)